<div class="input-group" [class]="class">
  <button class="btn btn-gold-outline-dark" type="button" (click)="dec()"><i class="fa-solid fa-minus"></i></button>
  <input type="text" class="form-control" [name]="name" [(ngModel)]="model" appInputRange [min]="min" [max]="max" readonly />
  <button class="btn btn-gold-outline-dark" type="button" (click)="inc()"><i class="fa-solid fa-plus"></i></button>
</div>
